import Splide from "@splidejs/splide";

function initSliderStudioSpecialisationDetail(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-studio-specialisation-detail").forEach((el) => {
		const sliderStudioSpecialisationDetail = new Splide(el, {
			mediaQuery: "min",
			perPage: 1.2,
			gap: "20px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			omitEnd: true,
			speed: 700,
			breakpoints: {
				640: { perPage: 2.5, gap: "20px" },
				1024: { perPage: 4, gap: "30px", drag: false },
			},
		});

		sliderStudioSpecialisationDetail.mount();
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderStudioSpecialisationDetail());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-studio-specialisation-detail", ($block) => {
		initSliderStudioSpecialisationDetail($block && $block.jquery ? $block.get(0) : $block);
	});
}
